const OVERLAY = {
    onReady() {
        document.addEventListener('click', OVERLAY.call); 
        OVERLAY.exit();
    },
    close(that) {
        let overlay = that.parentNode;
        overlay.style.display = 'none';
        document.body.classList.remove('noscroll');
        (that.classList.contains('exit-close')) && COOKIE.set({name: 'exit-overlay', value: 'true', days: 1});
    },
    call(event) {
        let anchor = event.target.closest('a');
        if (anchor === null) return;
        if (anchor.href.includes('/overlays/') === false) return;
        event.preventDefault();
        let xhr, responseText;
        (window.XMLHttpRequest) && (xhr = new XMLHttpRequest());
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4 && xhr.status === 200) {
                let html        = xhr.responseText;
                let mainContent = html.match(/(?=<main>).*?(<\/main>)/gs);
                let tempDOM     = document.createElement('html');
                tempDOM.innerHTML = `<html>${mainContent}</html>`;
                let overlayWrapper = tempDOM.querySelector('.overlay-id');
                let overlayId      = overlayWrapper.id;
                let container   = document.getElementById(overlayId);
                if (container === null) return;
                if (container.classList.contains('js-overlay')) {
                    container.style.display = 'block';
                    container.style.opacity = '1';
                    document.body.classList.add('noscroll');
                } else {
                    container.scrollIntoView({
                        behavior: 'auto',
                        block: 'center',
                        inline: 'center'
                    });
                }
                let form = container.querySelector('form');
                TRACKING.formEvents({
                    form: form, 
                    action: 'FORM-AUFRUF'
                });
                CLEAN.onReady();
            }
        }
        xhr.open('GET', anchor.href, true );
        xhr.send();
    },
    exit() {
        if (window.innerWidth < 960) return;
        const overlay = document.getElementById('exit-overlay');
        if (overlay === null) return;
        document.body.addEventListener('mouseleave', () => {
            if (COOKIE.get({name: 'exit-overlay'})) return;
            overlay.style.display = 'block';
            overlay.style.opacity = '1';
            document.body.classList.add('noscroll');
            CLEAN.onReady();
        });
    },
    loading() {
        let markup = `
        <div class="overlay--loading" id="overlay-loading">
            <div id="loading">
                <div class='overlay--loading__container--loader'>
                    <div class="loader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </div>
        </div>`;
        document.body.insertAdjacentHTML('afterbegin', markup);
    }
}